import React, { useState } from "react";
import styled from "styled-components";
import Heading, { HeadingVariants } from "../components/atoms/Heading";
import FormField from "../components/molecules/FormField";
import Button from "../components/atoms/Button";
import { useMutation } from "@tanstack/react-query";
import { initializeUser } from "../services/initializeUser";
import { QueryKeys } from "../services/types";
import StatusInfo, { StatusInfoVariant } from "../components/atoms/StatusInfo";

const AddUsernameForm = ({ userSession }: any) => {
  const [username, setUsername] = useState("");

  const {
    mutateAsync: initializeUserMutation,
    data,
    isLoading,
  } = useMutation({
    mutationFn: initializeUser,
    mutationKey: [QueryKeys.USERNAME, QueryKeys.POINTS, QueryKeys.TOTAL_POINTS],
  });

  const handleSubmitUsername = async () => {
    if (username.trim() !== "") {
      await initializeUserMutation(username);
      setUsername("");
    }
  };

  return (
    <StyledUsernameForm>
      <Heading variant={HeadingVariants.H1}>Add username</Heading>

      <FormField
        id="username"
        name="username"
        placeholder="Your username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        minLength={3}
        maxLength={20}
        required
      />

      <Button
        text="Set username"
        onClick={(e) => {
          e?.preventDefault();
          handleSubmitUsername();
        }}
        margin="20px 0"
        disabled={username.length < 3}
      />

      {isLoading && (
        <StatusInfo variant={StatusInfoVariant.LOADING} text="Loading" />
      )}

      {data?.error?.message && (
        <StatusInfo
          variant={StatusInfoVariant.ERROR}
          text={`${data.error.message}`}
        />
      )}
    </StyledUsernameForm>
  );
};

const StyledUsernameForm = styled.form`
  width: 95%;
  margin: auto;
  max-width: 400px;
`;

export default AddUsernameForm;
